import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromApp from '@store';
import { SpinnerService } from '@shared/spinner/spinner.service';
import { DisplayTableService } from '@core/helper/display-table.service';

@Component({
  selector: 'fc-display-table-base',
  templateUrl: './display-table-base.component.html',
  styleUrls: ['./display-table-base.component.scss'],
  standalone: false
})
export class DisplayTableBaseComponent {
  @Output() clickRow = new EventEmitter<any>();
  @Output() quickFilter = new EventEmitter<any>();

  sortMouseDownX = 0;

  constructor(
    readonly store: Store<fromApp.AppState>,
    readonly spinnerService: SpinnerService,
    public adminTableService: DisplayTableService
  ) {
  }

  onSortDown($event: MouseEvent) {
    this.sortMouseDownX = $event.clientX
  }

  onSortUp($event: MouseEvent, field: string) {
    let x = this.sortMouseDownX;
    if (this.sortMouseDownX == 0) {
      return;
    }
    this.sortMouseDownX = 0;
    if (Math.abs($event.clientX - x) < 4) {
      this.adminTableService.toggleMultiSort(field)
    }
  }
}
